import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import SharedSimilarSearchContent from '../../../components/organism/SharedSimilarSearchContent/SharedSimilarSearchContent';
import { getRequestBody, getProcessedProps } from './preProcessData';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Box from '../../../components/molecules/Box';
import { pageContentType } from '../../../utils/getContentType';
import { COMPONENT_NAME } from './locators';
import useStyles from './style';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { useMediaQuery } from '@material-ui/core';
import Picture from '../../../components/atoms/Picture';
const SimilarSearch = props => {
  const {
    getOtherBranchesStart,
    getMoreLikeThisStart,
    otherBranchesData,
    moreLikeThisData,
    moreLikeThisDataTotalCount = null,
  } = props;
  const { title, ctaLink } = get(props, 'fields', '');
  const { params } = props || {};
  const variation =
    (get(params, 'variation.length') > 0 && params.variation) || 'MoreLikeThis';
  const isADRelatedEvents = variation === 'RelatedEvents';
  const classes = useStyles(props);
  let isEditor;
  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);
  const isMobile = useMediaQuery(`(max-width:${1023}px)`);
  const [slideOffset, setSlideOffset] = useState(0);
  const slideInitialLimit = 6
  // const slideInitialLimit = 5
  const slideAfterLimit = 4
  // const slideAfterLimit = isMobile ? 5 : 2
  const [slideLimit, setSlideLimit] = useState(slideInitialLimit);
  const totalSlides = moreLikeThisDataTotalCount && moreLikeThisDataTotalCount < 49 ? moreLikeThisDataTotalCount : 49
  const [eventCardsItem, setEventCardsItem] = useState({
    // fields: { cardList: isMobile ? [undefined] : new Array(totalSlides).fill(undefined) },
    fields: { cardList: [] },
  });

  const hasSupergraphicImage = !!get(props, 'fields.supergraphicImage.value.src')
  const componentSupergraphicImage = get(props, 'fields.supergraphicImage', null);
  useEffect(() => {
    const newCardList = isMobile ? [undefined] : new Array(totalSlides).fill(undefined);
    setEventCardsItem({ fields: { cardList: newCardList } });
  }, [isMobile]);

  const previewMode =
    props &&
    props.sitecoreContext &&
    props.sitecoreContext.pageState &&
    props.sitecoreContext.pageState.toLowerCase();

  if (isExperienceEditorActive() || previewMode === 'preview') {
    isEditor = true;
  } else {
    isEditor = false;
  }

  const placeholders = get(props.sitecoreContext, 'VADStaticRoute.sitecore.route.placeholders', '');
  const vadHeader = get(placeholders, 'vad-header', []);

  const hitApi = (offset = null) => {
    if (variation === 'MoreLikeThis' || isADRelatedEvents) {
      getMoreLikeThisStart(getRequestBody(props, variation, isEditor, offset ?? slideOffset, slideLimit));
    } else if (variation === 'Branches') {
      getOtherBranchesStart(getRequestBody(props, variation, isEditor, offset ?? slideOffset, slideLimit));
    }
  }

  const debouncedHitApi = debounce(hitApi, 1000);

  const getSlideIndex = (currIndex) => {
    if (!slideOffset) setSlideOffset(slideInitialLimit)
    if (slideLimit === slideInitialLimit) setSlideLimit(slideAfterLimit)
    else {
      if (currIndex > slideOffset) {
        if (isMobile) {
          debouncedHitApi(slideOffset);
        }
        else {
          hitApi(slideOffset)
        }
        setSlideOffset((prevState) => prevState + slideAfterLimit)
      }
    }
  }

  useEffect(() => {
    const favouriteBasket = vadHeader.find(item => item.componentName === 'FavoriteBasket');
    const favIsActive = get(favouriteBasket, 'fields["Is Active"].value', false);
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive)
  }, [vadHeader])

  useEffect(() => {
    if (get(props, 'sitecoreContext.language', false)) {
      hitApi()
    }
  }, []);
  useEffect(() => {
    if (moreLikeThisData.length || otherBranchesData.length) {
      const updatedFields = { ...eventCardsItem.fields };
      // If Mobile, push items before the last items which is undefined
      // If Desktop, Check the undefined item index and start pushing the items from that index
      if (isMobile && updatedFields.cardList.length > (totalSlides + 1)) {
        return
      }

      const cardItems = (variation === 'MoreLikeThis' || isADRelatedEvents) ? moreLikeThisData : otherBranchesData;
      const insertIndex = isMobile ? updatedFields.cardList.length - 1 : updatedFields.cardList.indexOf(undefined);

      if (insertIndex !== -1) {
        // If Mobile push new data before the last index, If Desktop push the data where you find first undefined item (override)
        const cardListToAdd = getProcessedProps(props, cardItems).fields.cardList;
        updatedFields.cardList.splice(insertIndex, isMobile ? 0 : slideLimit, ...cardListToAdd);
      }
      setEventCardsItem(prevState => ({
        ...prevState,
        fields: updatedFields,
      }));
    }
  }, [moreLikeThisData, otherBranchesData]);

  let expectedProps = {
    ...eventCardsItem,
    fields: {
      ...eventCardsItem.fields,
      title,
      ctaLink,
      description: { value: get(ctaLink, 'value.text', '') },
      variation,
      pageContentType: pageContentType(props)?.toLowerCase(),
      pageName: getPageName(props),
      componentName: getComponentName(props),
      aspectRatioNeeded: true,
      appConfig: props.appConfig,
    },
  };

  // Putting this condition only in case of AD Related Events
  const shouldRender = isADRelatedEvents ? get(props, 'sitecoreContext.route.fields.eventCategories', []).length > 0 : true;

  let isCardAvailable = get(eventCardsItem, 'fields.cardList', []);
  isCardAvailable = isCardAvailable && isCardAvailable.some(item => item !== undefined)
  // If there is no cardItem avaialble then component will not render anything
  return shouldRender && isCardAvailable ? (
    <Box className={clsx(classes.root, 'withBg', 'isApplyHeight', isADRelatedEvents && 'isADRelatedEvents')} data-locator={COMPONENT_NAME}>
      {params?.backgroundColor && <div className='infographicsbgImage-moreLikethis'></div>}

      {
        hasSupergraphicImage &&
        <Box
          className={'bg-wrapper'}
        >
          {<Picture media={{ image: componentSupergraphicImage }} />}
        </Box>
      }
      {
        <SharedSimilarSearchContent
          isADRelatedEvents={isADRelatedEvents}
          {...expectedProps}
          hasFavouriteBasket={hasFavouriteBasket}
          getCurrentIndex={getSlideIndex}
          totalLimit={totalSlides}
        />
      }
    </Box>
  ) : null;
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(SimilarSearch))
);
